import estilos from "./Layout.module.css";
import { useTheme, type Theme } from "./tema";

const LABEL: Record<Theme, string> = {
  system: "Tema: automático",
  light: "Tema: claro",
  dark: "Tema: escuro",
};
const ICON: Record<Theme, string> = { system: "◐", light: "☀", dark: "☾" };

/** Cycles the theme: automatic (system) → light → dark. */
export function BotaoTema() {
  const [theme, next] = useTheme();
  return (
    <button
      type="button"
      className={estilos.tema}
      onClick={next}
      title={`${LABEL[theme]} (clique para trocar)`}
    >
      <span aria-hidden="true">{ICON[theme]}</span>
      <span className="visualmente-oculto">{LABEL[theme]}, trocar</span>
    </button>
  );
}
